import { render, staticRenderFns } from "./AnexoBilly.vue?vue&type=template&id=3613265c&scoped=true&"
import script from "./AnexoBilly.vue?vue&type=script&lang=js&"
export * from "./AnexoBilly.vue?vue&type=script&lang=js&"
import style0 from "./AnexoBilly.vue?vue&type=style&index=0&id=3613265c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613265c",
  null
  
)

export default component.exports